import { render } from "./CommoditySlider.vue?vue&type=template&id=bc5c8164"
import script from "./CommoditySlider.vue?vue&type=script&lang=js"
export * from "./CommoditySlider.vue?vue&type=script&lang=js"

import "./CommoditySlider.vue?vue&type=style&index=0&id=bc5c8164&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__